var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"created"},[_c('weui-group',{attrs:{"title":"您已经向私人教练提出了以下时段的课程申请","tips":"稍后教练将为您做出安排"}},[_c('weui-cell',[_vm._v(_vm._s(_vm.course && _vm.course.date_text))])],1),_vm._v(" "),_c('weui-group',[_c('weui-button-cell',{attrs:{"to":{ name: _vm.ROUTE_COURSE_HOME }}},[_vm._v("返回课程安排")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c8d7c30","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/course/Created.vue
// module id = null
// module chunks = 